class CreatePatientProgramReq{
    constructor(){
    this.patientId = undefined;
    this.programEntries = undefined;
    this.programId = undefined;
    this.name = undefined;
    }
}

export default CreatePatientProgramReq;